import FoldedArrow from './folded-arrow.js'

export default class RightOutwardFoldedArrow extends FoldedArrow {

  handles = [{
    // Arrow head height/width
    defaults: [.85, .65],
    constraints: (dimensions, handles) => {
      return [
        this._constraints.x,
        this._constraints.y
      ]
    },
    cursor: 'all-scroll'
  }, {
    // base length of the arrow
    defaults: [null, .5],
    constraints: [null, [0, 1]],
    cursor: 'ns-resize'
  }]

  /*
   * Sets the internal constraints for the y value of the first handle (armpit of the arrow.)
   * This is dependent on the `x` value of the first handle handle.
   */
  _setYConstraints (dimensions, pointerHeight, handles) {
    const y = this.findConstraint(dimensions, pointerHeight, handles, 'y')
    return [y, 1]
  }

  /*
   * Sets the internal constraints for the x value of the first handle (armpit of the arrow.)
   * This is dependent on the `y` value of the first handle handle.
   */
  _setXConstraints (dimensions, pointerHeight, handles) {
    const x = this.findConstraint(dimensions, pointerHeight, handles, 'x')
    return [0.82, x]
  }

  getProperties (dimensions, handles) {
    return {
      arrowWidth: (dimensions.width - dimensions.width * handles[0][0]) * 2,
      arrowHeight: dimensions.height - dimensions.height * handles[0][1]
    }
  }

  updateHandles (handles, dimensions) {
    handles[0][0] = (dimensions.width - this.properties.arrowWidth / 2) / dimensions.width
    handles[0][1] = Math.max(1 - this.properties.arrowHeight / dimensions.height, .01) // don't let the armpit go too high

    // center this handle horizontally on the arrow base
    const offset = this.curveData.right.outer.at(-1)[0] - this.curveData.tipPoint[0]
    handles[1][0] = offset / dimensions.width
  }

  onHandleChange (handle, diff, handles, dimensions) {
    // Now we want to reset the constraints for the handles. It's more performant to do this
    // after all the handle changes have been made, rather than repeating calls in the `constraints` method.
    const pointerHeight = dimensions.height - dimensions.height * handles[0].coords[1]

    if (handle.idx === 0) {
      // moving the armpit control
      if (diff[0]) {
        // x value changed, recalculate the y constraints
        this._constraints.y = this._setYConstraints(dimensions, pointerHeight, handles.map(h => h.coords))
      }

      if (diff[1]) {
        // y value changed, update the x constraints
        this._constraints.x = this._setXConstraints(dimensions, pointerHeight, handles.map(h => h.coords))
      }
    }

    // Reset the properties
    this.properties = this.getProperties(dimensions, handles.map(h => h.coords))
  }

  getFlattenedPaths (data, dimensions) {
    const handles = structuredClone(this.getHandles(dimensions).map(handle => handle.coords))
    handles[0][0] = .84
    handles[1][0] = .7

    const paths = this.getPaths(data, dimensions, handles)
    paths.at(-1).fill = paths.at(0).fill
    paths.at(-1).stroke = paths.at(0).stroke
    paths.at(-1).strokeWidth = paths.at(0).strokeWidth
    return paths
  }

  generateCurvePaths (data, dimensions, handles) {
    const pointerHeight = dimensions.height - dimensions.height * handles[0][1]
    return this.getCurvePaths(dimensions, this.curveData, dimensions.height * handles[1][1], pointerHeight)
  }

}

